<template>
 <div class="head">
    <i class="icon close-icon" v-if="showClose" @click="closeIm">关闭</i>
    <i class="icon iconfont icon-fanhui1 back-icon" @click="goBack" v-if="showBack"></i>
    <div class="head-title">{{title}}</div>
    <div class="right-area">
      <slot name="rightArea"></slot>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  props: {
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 小程序退出im
    closeIm () {
      wx.miniProgram.navigateBack() // 返回小程序
    },
    goBack () {
      this.$emit('back')
    }
  }
}
</script>

<style lang="less" scoped>
.head{
  position: relative;
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: var(--main-color);
  color: #fff;
  .close-icon{
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    font-style: normal;
    // font-size: 20px;
  }
  .back-icon{
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 16px;
  }
  .head-title{
    font-size: 18px;
    text-align: center;
  }
  .right-area{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue